<div class="flex-container">
  <div class="step-container">
    <div class="step-text-container">
      <span>Reuse configuration</span>
    </div>
    <div class="step-button-container">
      <button mat-mini-fab (click)="step(0)" class="{{currentStep === 0 ? 'selected-menu' : 'menu-button'}}"> 0</button>
      <app-help-icon-button *ngIf="currentStep === 0" [code]="'kfconfiguration.PutOnMarket.Reporting.InitialStep'"></app-help-icon-button>
    </div>
  </div>
  <div class="step-container">
    <div class="step-text-container">
      <span>Reporting Groups</span>
      <app-help-icon-button *ngIf="currentStep === 1" [code]="selectedIndex == 0 ? 'kfconfiguration.PutOnMarket.Reporting' : 'kfconfiguration.Collected.Reporting'"></app-help-icon-button>
    </div>
    <div class="step-button-container">
      <button mat-mini-fab (click)="step(1)" class="{{currentStep === 1 ? 'selected-menu' : 'menu-button'}}"> 1</button>
    </div>
  </div>
  <div class="step-container">
    <div class="step-text-container">
      <span>Groups Definition</span>
      <app-help-icon-button *ngIf="currentStep === 2" [code]="selectedIndex2 == 0 ? 'kfconfiguration.PutOnMarket.Groups' : 'kfconfiguration.Collected.Groups'"></app-help-icon-button>
    </div>
    <div class="step-button-container">
      <button mat-mini-fab (click)="step(2)" class="{{currentStep === 2 ? 'selected-menu' : 'menu-button'}}"> 2</button>
    </div>
  </div>
  <div class="step-container">
    <div class="step-text-container">
      <span>Launch</span>
      <app-help-icon-button *ngIf="currentStep === 3" [code]="'kfconfiguration.Launch'"></app-help-icon-button>
    </div>
    <div class="step-button-container">
      <button mat-mini-fab (click)="step(3)" class="{{currentStep === 3 ? 'selected-menu' : 'menu-button'}}"> 3</button>
    </div>
  </div>
</div>
